import { useState, ReactElement } from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import IconButton from '@material-ui/core/IconButton';
import CreateIcon from '@mui/icons-material/Create';
import DeleteIcon from '@mui/icons-material/Delete';
import Button from '~/ui/components/common/Button';

import EditProgram from './EditProgram';
import PhysiciansModal from './PhysiciansModal';
import NotificationRulesModal from './NotificationRulesModal';

import { IProgramList } from '~/services/api/programs/types';
import { IPagePermissions } from '../../types';
import styles from './Item.module.scss';

interface IProps {
  program: IProgramList;
  permissions: IPagePermissions;
  onRemove: (program: IProgramList) => void;
}

const Item = ({ program, permissions, onRemove }: IProps): ReactElement => {
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [showPhysiciansPopup, setShowPhysiciansPopup] = useState(false);
  const [showRulesPopup, setShowRulesPopup] = useState(false);

  return (
    <>
      <TableRow>
        <TableCell className={styles.name}>{program.name}</TableCell>
        <TableCell className={styles.cellCenter}>{program.timezone}</TableCell>
        <TableCell className={styles.cellCenter}>{program.activeUsersCount}</TableCell>
        <TableCell className={styles.cellCenter}>{program.activePatientsCount}</TableCell>
        <TableCell className={styles.cellCenter}>
          <div className={styles.actions}>
            <Button
              size="small"
              variant="contained"
              color="primary"
              onClick={() => setShowPhysiciansPopup(true)}
            >
              Physicians
            </Button>
            <Button
              size="small"
              variant="contained"
              color="primary"
              onClick={() => setShowRulesPopup(true)}
            >
              Notification Rules
            </Button>
          </div>
        </TableCell>
        <TableCell width={50} align="center">
          <IconButton className={styles.icon} title="Edit" onClick={() => setShowEditPopup(true)}>
            <CreateIcon />
          </IconButton>
        </TableCell>
        {permissions.canRemoveProgram && (
          <TableCell width={50} align="center" className={styles.removeCell}>
            <IconButton className={styles.icon} title="Remove" onClick={() => onRemove(program)}>
              <DeleteIcon />
            </IconButton>
          </TableCell>
        )}
      </TableRow>
      {showEditPopup && (
        <EditProgram programId={program.id} onClose={() => setShowEditPopup(false)} />
      )}
      {showPhysiciansPopup && (
        <PhysiciansModal programId={program.id} onClose={() => setShowPhysiciansPopup(false)} />
      )}
      {showRulesPopup && (
        <NotificationRulesModal programId={program.id} onClose={() => setShowRulesPopup(false)} />
      )}
    </>
  );
};

export default Item;
